import React from "react";

import {
  withTheme,
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  List,
  ListItem,
  Paper,
  Avatar,
  ListItemText,
  Divider,
  Button,
  Typography,
  CircularProgress,
  Badge,
  Checkbox,
  Input,
} from "@material-ui/core";
import {
  Close,
  ArrowRight,
  AddCircleOutline,
  RemoveCircleOutline,
  LocalShipping,
  LocationOn,
  Error as ErrorIcon,
  Edit,
} from "@material-ui/icons";
// import Swipe from 'react-easy-swipe'
import { getImageUrl } from "../../framework/getImageUrl";
import s from "./shoppingCart.module.css";
import moment from "moment";
import { theme } from "../../framework/theme";
import GlobalContext from "../../context/globalContext";
import { SDKContext } from "../../context/SDKContext";
import FFLogo from "../../assets/ff.png";
import { Formik, Form } from "formik";
import cx from "classcat";

// import { isBrowser } from 'react-device-detect'
import PayDialog from "./placeOrderModal";
import { getValidationErrors } from "../sharedComponents/getValidationErrors";

// import { StripeProvider } from "react-stripe-elements";

function Transition(props) {
  return <Slide direction={props.direction} in={true} {...props} />;
}

class ShoppingCartDialog extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      orderProcessing: false,
      payDialogState: false,
      wait: 0,
      updated: true,
      checking: false,
      referralCode: null,
      applyCredit: true,
      controlledCartItemAcknowledged: false,
    };
  }

  componentDidMount() {
    setInterval(this.checkSubmitShoppingCartChanges.bind(this), 5000);
  }

  async checkSubmitShoppingCartChanges() {
    const { shoppingCart, shoppingCartDialogState } = this.context.global.data;
    const { checking, updated } = this.state;
    let totalItems = 0;
    if (shoppingCart && !checking && updated) {
      this.setState({ checking: true });
      if (shoppingCart.calculatedInventoryItems) {
        for (let ciiIndex in shoppingCart.calculatedInventoryItems) {
          totalItems =
            shoppingCart.calculatedInventoryItems[ciiIndex].quantityInCart +
            totalItems;
        }
        if (
          totalItems !== shoppingCart.cartDetails.numberOfItems &&
          shoppingCartDialogState
        ) {
          this.setState({ updated: false });
          await this.context.global.submitShoppingCartChanges();
          this.setState({ checking: false, updated: true });
        } else {
          this.setState({ checking: false });
        }
      }
    }
  }

  addItem = async (item) => {
    if (!this.state.checking && this.state.updated) {
      await this.context.global.modifyShoppingCart(item, false);
    } else {
    }
  };

  removeItem = async (item) => {
    if (!this.state.checking && this.state.updated) {
      await this.context.global.modifyShoppingCart(item, true);
    } else {
    }
  };

  openPayDialog = async () => {
    this.setState({ checking: true });
    let changes = await this.context.global.submitShoppingCartChanges();
    // await this.checkSubmitShoppingCartChanges()
    if (
      this.context.global.data.shoppingCart.cartDetails.numberOfItems === 0 ||
      this.context.global.data.shoppingCartSubmitting ||
      changes
    ) {
      this.context.global.openErrorSnackbar(
        "Cart Updated.  Please verify new cart and proceed to payment"
      );
      this.setState({ checking: false });

      return null;
    } else {
      await this.context.global.getUserByUuid();
      await this.context.global.getPopUpLocationInstanceCheck();
      this.setState({ checking: false });

      this.setState({ payDialogState: true });
    }
  };

  placeOrder = async (
    shoppingCartUuid,
    paymentOptionUuid,
    paymentOption,
    tipAmountDollars
  ) => {
    this.setState({ orderProcessing: true, checking: true });

    await this.context.global.submitShoppingCartChanges();
    this.setState({ checking: false });

    // await this.checkSubmitShoppingCartChanges()
    if (this.context.global.data.shoppingCart.cartDetails.numberOfItems === 0) {
      this.setState({ orderProcessing: false, payDialogState: false });
      this.context.global.openErrorSnackbar(
        "Internal Server Error, there appears to be an empty cart"
      );
      return null;
    }
    let order;
    try {
      order = await this.context.global.placeOrder(
        shoppingCartUuid,
        paymentOption === 1 ? paymentOptionUuid : null,
        this.state.applyCredit,
        this.state.referralCode == null
          ? undefined
          : this.state.referralCode.code,
        tipAmountDollars * 100
      );
    } catch (err) {
      this.setState({ orderProcessing: false });
      this.setState({ payDialogState: false });
      return null;
    }
    this.context.global.setGlobalState("newCartCreated", true);
    await this.context.global.getUserOrders();
    this.props.history.push(`/orders/${order.uuid}`);
    this.setState({ orderProcessing: false });
    this.context.global.setGlobalState("shoppingCartDialogState", false);
    this.context.global.setGlobalState("dashboardHistory", []);
    this.context.global.setGlobalState("chooseSavingsDialogState", false);
    this.context.global.setGlobalState("dashboardpageYOffset", 0);
    // const shoppingCart = await this.context.global.getCurrentShoppingCart();
    // await this.context.global.getGroupCategories(
    //   shoppingCart.popUpLocationInstance.uuid
    // );
    // await this.context.global.getMoreGroupCategories(
    //   shoppingCart.popUpLocationInstance.uuid
    // );
    // await this.context.global.getMoreGroupCategories(
    //   shoppingCart.popUpLocationInstance.uuid
    // );
    // await this.context.global.getMoreGroupCategories(
    //   shoppingCart.popUpLocationInstance.uuid
    // );
    // this.context.global.getUserFavorites();
    // this.context.global.getUserReorderItems();
    // this.context.global.setGlobalState("");
    this.context.global.openSuccessSnackbar("Order Placed!");
  };

  applyCreditHandler = (ev) => {
    this.setState({ applyCredit: !this.state.applyCredit });
  };

  closeShoppingCart = () => {
    // this.context.global.setGlobalState('shoppingCartDialogState', false)
    this.context.global.handleDashboardActions(
      "BACK",
      "shoppingCartDialogState"
    );
    this.context.global.setGlobalState(
      "bottomNavigationValue",
      "homeDialogState"
    );
    this.context.global.submitShoppingCartChanges();
  };

  render() {
    const { theme } = this.props;
    const {
      shoppingCart,
      shoppingCartDialogState,
      shoppingCartDialogDirection,
      user,
      controlledCartItem,
    } = this.context.global.data;
    const {
      orderProcessing,
      updated,
      checking,
      applyCredit,
      controlledCartItemAcknowledged,
    } = this.state;

    if (!shoppingCart) {
      return null;
    }

    // let address = _.head(user.locations.filter(l => l.isPrimary));
    let address = shoppingCart.deliveryLocation;

    let localShoppingCartItemCount;
    if (shoppingCart.calculatedInventoryItems.length > 0) {
      localShoppingCartItemCount = shoppingCart.calculatedInventoryItems
        .map((item) => item.quantityInCart)
        .reduce((acc, c) => acc + c);
    }

    const moneyFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const creditAmount = applyCredit
      ? Math.min(user.credits.totalCredit, shoppingCart.cartDetails.cartTotal)
      : 0;
    const totalAfterCredits = Math.max(
      shoppingCart.cartDetails.cartTotal - creditAmount,
      0
    );
    const refereeAmount =
      this.state.referralCode == null
        ? null
        : this.state.referralCode.referralTemplate.refereeAmountKind === "FIXED"
          ? this.state.referralCode.referralTemplate.refereeAmount
          : totalAfterCredits *
          (this.state.referralCode.referralTemplate.refereeAmount / 100);

    let deliveryFee = shoppingCart.cartDetails.deliveryFee ? moneyFormatter.format(parseInt(shoppingCart.cartDetails.deliveryFee)) : 0
    let serviceFee = shoppingCart.cartDetails.serviceFee ? moneyFormatter.format(parseInt(shoppingCart.cartDetails.serviceFee)) : 0
    
    const totalAmount =
      Math.max( totalAfterCredits - (refereeAmount == null ? 0 : refereeAmount), 0) + deliveryFee + serviceFee;

    const canOrder = shoppingCart.cartDetails.canOrder;

    return (
      <>
        <Dialog
          fullScreen
          open={shoppingCartDialogState}
          onClose={this.closeShoppingCart}
          TransitionComponent={Transition}
          transitionDuration={{ enter: 300, exit: 300 }}
          TransitionProps={{ direction: shoppingCartDialogDirection }}
          style={{ zIndex: 90002 }}
        >
          <AppBar className={s.shoppingCartAppBar}>
            <Toolbar className={s.shoppingCartToolbar}>
              <div className={s.appBarContentContainer}>
                <div className={s.addressContainer}>
                  <div className={s.shoppingCartContainer}>
                    {shoppingCart.popUpLocationInstance.fulfillmentType ===
                      "PICKUP"
                      ? shoppingCart.popUpLocationInstance.popUpLocation.name
                      : null}
                  </div>
                  <div className={s.address}>
                    {moment(
                      shoppingCart.popUpLocationInstance.pickupTimestampStart *
                      1000
                    ).format("M/D @ h:mma")}
                  </div>
                </div>
              </div>
              <div className={s.closeButtonContainer}>
                <IconButton
                  color="inherit"
                  onClick={this.closeShoppingCart}
                  aria-label="Close"
                  className={s.shoppingCartAppBar}
                >
                  <Close />
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          <div style={{ marginTop: 70 }} />
          {/* {isBrowser ? null : (
            <div className={s.swipeInfo}>
              <div className={s.swipeInfoDirections}>
                <ArrowBack className={s.swipeIcon} />
                <div>REMOVE</div>
              </div>
              <div className={s.swipeInfoDirections}>Swipe to Modify Cart</div>
              <div className={s.swipeInfoDirections} style={{ justifyContent: 'flex-end' }}>
                <div>ADD</div>
                <ArrowForward className={s.swipeIcon} />
              </div>
            </div>
          )} */}

          {shoppingCart.calculatedInventoryItems.length !== 0 ? (
            <>
              <div
                className={s.basketTitle}
              // style={{ color: theme.palette.primary.main }}
              >
                Shopping Cart
              </div>
              {canOrder.status === false ? (
                <div className={s.cannotOrderPanel}>
                  <ErrorIcon />
                  <span>{canOrder.message}</span>
                </div>
              ) : null}
              {canOrder.status === true &&
                controlledCartItem &&
                !controlledCartItemAcknowledged ? (
                <div className={s.cannotOrderPanel}>
                  <ErrorIcon />
                  <span>
                    By checking this box, I confirm that I am at least 21 years
                    of age and will have a valid ID to present when I receive my
                    order.
                    <br />
                    <span>
                      <Checkbox
                        checked={controlledCartItemAcknowledged}
                        onChange={() =>
                          this.setState({
                            controlledCartItemAcknowledged: !controlledCartItemAcknowledged,
                          })
                        }
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                      I Acknowledge this requirement.
                    </span>
                  </span>
                </div>
              ) : null}
              <List className={s.shoppingCartListContainer}>
                {shoppingCart.calculatedInventoryItems.map((item) => {
                  return (
                    <ShoppingListItem
                      key={item.uuid}
                      item={item}
                      shoppingCart={shoppingCart}
                      addItem={this.addItem}
                      removeItem={this.removeItem}
                    />
                  );
                })}
              </List>
              {canOrder.status === false ? null : (
                <ReferralSection
                  setDisableChoosingPayment={(value) => {
                    this.setState({ checking: value });
                  }}
                  setReferralCode={(value) => {
                    this.setState({ referralCode: value });
                  }}
                />
              )}
              {user.credits.totalCredit > 0 ? (
                <Paper
                  className={s.paymentCardContainer}
                  onClick={this.applyCreditHandler.bind(this)}
                  style={{ background: "white" }}
                >
                  <Checkbox
                    name="applyCredit"
                    style={{
                      marginLeft: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      marginRight: 0,
                    }}
                    checked={applyCredit}
                    value={applyCredit}
                  />
                  <div style={{ flex: 1, paddingLeft: 5 }}>
                    Apply credit to this order (Total credit remaining: $
                    {applyCredit
                      ? (
                        Math.max(
                          user.credits.totalCredit -
                          shoppingCart.cartDetails.cartTotal,
                          0
                        ) / 100
                      ).toFixed(2)
                      : (user.credits.totalCredit / 100).toFixed(2)}
                    )
                  </div>
                </Paper>
              ) : null}
              <List>
                <ListItem className={s.taxContainer}>
                  <div className={s.tax}>
                    <div className={s.label}>TAX</div>
                    <div className={s.value}>$0.00</div>
                  </div>
                </ListItem>
                {true ? (
                  <>
                    <ListItem className={s.totalContainer}>
                      <div className={s.total}>
                        <div className={s.label}>SUBTOTAL</div>

                        <div className={s.value}>
                          {moneyFormatter.format(
                            shoppingCart.cartDetails.cartTotal / 100
                          )}
                        </div>
                      </div>
                    </ListItem>
                    <ListItem className={s.taxContainer}>
                      <div className={s.tax}>
                        <div className={s.label}>CREDIT</div>
                        <div className={s.value}>
                          -{moneyFormatter.format(creditAmount / 100)}
                        </div>
                      </div>
                    </ListItem>
                    {refereeAmount == null ? null : (
                      <ListItem className={s.taxContainer}>
                        <div className={s.tax}>
                          <div className={s.label}>DISCOUNT</div>
                          <div className={s.value}>
                            -{moneyFormatter.format(refereeAmount / 100)}
                          </div>
                        </div>
                      </ListItem>
                    )}
                    {shoppingCart.cartDetails.deliveryFee == null ? null : (
                      <ListItem className={s.taxContainer}>
                        <div className={s.tax}>
                          <div className={s.label}>DELIVERY FEE</div>
                          <div className={s.value}>
                            {moneyFormatter.format(
                              shoppingCart.cartDetails.deliveryFee / 100
                            )}
                          </div>
                        </div>
                      </ListItem>
                    )}
                    {shoppingCart.cartDetails.serviceFee == null ? null : (
                      <ListItem className={s.taxContainer}>
                        <div className={s.tax}>
                          <div className={s.label}>SERVICE FEE</div>
                          <div className={s.value}>
                            {moneyFormatter.format(
                              shoppingCart.cartDetails.serviceFee / 100
                            )}
                          </div>
                        </div>
                      </ListItem>
                    )}
                  </>
                ) : null}
                <ListItem className={s.totalContainer}>
                  <div className={s.total}>
                    <div className={s.label}>TOTAL</div>
                    <div className={s.totalValue}>
                      {moneyFormatter.format(totalAmount / 100)}
                    </div>
                  </div>
                </ListItem>
              </List>
              {shoppingCart.cartDetails.totalSavingsAvailable >= 0.1 ? (
                <Paper
                  className={s.saveCard}
                  onClick={() => {
                    this.context.global.setGlobalState(
                      "chooseSavingsDialogState",
                      true
                    );
                  }}
                >
                  <div className={s.logoContainer}>
                    <img src={FFLogo} alt={""} width={"50%"} />
                  </div>
                  <div className={s.saveCardContent}>
                    <div className={s.saveCardTitle}>
                      Wanna save some more money?
                    </div>
                    <div className={s.saveCardDescription}>
                      Looks like you could save an additional $
                      {(
                        shoppingCart.cartDetails.totalSavingsAvailable / 100
                      ).toFixed(2)}{" "}
                      if you switch your cart around a bit.
                    </div>
                  </div>
                  <div className={s.saveCardRight}>
                    <ArrowRight
                      fontSize={"large"}
                      style={{ color: theme.palette.primary.main }}
                    />
                  </div>
                </Paper>
              ) : null}

              <Paper
                className={s.paymentCardContainer}
                style={
                  shoppingCart.popUpLocationInstance.fulfillmentType ===
                    "DELIVERY"
                    ? { backgroundColor: "white", padding: 25, paddingLeft: 15 }
                    : { padding: 25, paddingLeft: 15 }
                }
                onClick={
                  shoppingCart.popUpLocationInstance.fulfillmentType ===
                    "DELIVERY"
                    ? () =>
                      this.context.global.handleOpenNewUserDeliveryLocationDialog()
                    : null
                }
              >
                {shoppingCart.popUpLocationInstance.fulfillmentType ===
                  "DELIVERY" ? (
                  <LocalShipping
                    style={{
                      color: theme.palette.primary.main,
                      marginLeft: 0,
                      paddingLeft: 0,
                    }}
                  />
                ) : (
                  <LocationOn
                    style={{
                      color: theme.palette.primary.main,
                      marginLeft: 0,
                      paddingLeft: 0,
                    }}
                  />
                )}
                <div style={{ flex: 1, paddingLeft: 15 }}>
                  {shoppingCart.popUpLocationInstance.fulfillmentType ===
                    "DELIVERY" ? (
                    <>
                      <div style={{ fontWeight: "bold" }}>DELIVERY</div>
                      <div>
                        {address.address1} {address.address2}
                      </div>
                      <div>
                        {address.city} {address.zip}
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ fontWeight: "bold" }}>
                        PICKUP -{" "}
                        <span style={{ fontWeight: "normal", color: "#333" }}>
                          {
                            shoppingCart.popUpLocationInstance.popUpLocation
                              .name
                          }
                        </span>
                      </div>
                      <div>
                        {
                          shoppingCart.popUpLocationInstance.popUpLocation
                            .address1
                        }
                      </div>
                      <div>
                        {shoppingCart.popUpLocationInstance.popUpLocation.city}{" "}
                        {shoppingCart.popUpLocationInstance.popUpLocation.zip}
                      </div>
                    </>
                  )}

                  {/* Using card ending in 2223 */}
                </div>
                {/* {' '}
          <div style={{ flex: 0.1, color: theme.palette.primary.main }}>
                change
              </div>  */}
                {/* <ArrowRight style={{ color: theme.palette.primary.main }} /> */}
              </Paper>
            </>
          ) : (
            <Typography
              variant="body1"
              style={{
                // color: theme.palette.primary.main,
                color: "#222222",
                padding: "50px 20px",
                textAlign: "center",
              }}
            >
              Nothing in your cart yet!
            </Typography>
          )}

          <div style={{ minHeight: 100 }}></div>
          <div className={s.shoppingCartDialogbuttonContainer}>
            <Button
              disabled={
                canOrder.status === false ||
                  localShoppingCartItemCount < 1 ||
                  shoppingCart.calculatedInventoryItems.length === 0 ||
                  orderProcessing ||
                  checking ||
                  (!controlledCartItemAcknowledged && controlledCartItem) ||
                  !updated
                  ? true
                  : false
              }
              style={{ height: "2.25rem", flex: 1 }}
              onClick={async () => {
                this.openPayDialog();
              }}
            >
              {orderProcessing ||
                checking ||
                this.context.global.data.shoppingCartSubmitting ? (
                <CircularProgress style={{ height: 25, width: 25 }} />
              ) : (
                "Choose Payment Option"
              )}
            </Button>
          </div>
        </Dialog>
        <PayDialog
          shoppingCart={shoppingCart}
          payDialogState={this.state.payDialogState}
          orderProcessing={orderProcessing}
          placeOrder={this.placeOrder.bind(this)}
          closePayDialog={() => this.setState({ payDialogState: false })}
          theme={theme}
          puli={shoppingCart.popUpLocationInstance}
        />
      </>
    );
  }
}

export default withTheme()(ShoppingCartDialog);

class ShoppingListItem extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);
    this.state = {
      left: 0,
      fixed: false,
      addOrSubtract: "add",
      yPosition: 0,
      item: props.item,
      timeouts: [],
      isEditingCustomerNote: false,
    };
  }

  componentWillUnmount() {
    this.state.timeouts.map((t) => clearTimeout(t));
  }

  toggleCustomerNoteEdit = () => {
    this.setState({ isEditingCustomerNote: !this.state.isEditingCustomerNote });
  };

  render() {
    const {
      modifyShoppingCartItemNote,
      openErrorSnackbar,
    } = this.context.global;
    const { item, addItem, removeItem, shoppingCart } = this.props;
    const { isEditingCustomerNote } = this.state;

    return (
      <div key={shoppingCart.uuid}>
        <>
          <ListItem
            className={s.listItem}
            key={item.uuid}
            style={{
              left: this.state.left,
              marginLeft: this.state.left,
              justifyContent: "space-between",
            }}
          >
            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              > */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                minWidth: "130px",
                justifyContent: "space-between",
              }}
            >
              <div
                className={s.lessItemsButton}
                onClick={() => removeItem(item)}
              >
                <RemoveCircleOutline fontSize="large" />
              </div>

              {item.quantityInCart ? (
                <Badge badgeContent={item.quantityInCart} color="secondary">
                  <Avatar src={getImageUrl(item.imageUrl)} />
                </Badge>
              ) : (
                <Avatar src={getImageUrl(item.imageUrl)} />
              )}

              <div className={s.moreItemsButton} onClick={() => addItem(item)}>
                <AddCircleOutline fontSize="large" />
              </div>
            </div>

            <ListItemText
              className={s.listItemText}
              primary={
                <span style={{ fontSize: "smaller" }}>
                  {!item.isSelect ? item.brand : null} {item.name}
                </span>
              }
              secondary={`${item.sizeDisplay}`}
            />

            <div className={s.itemPrice_containter}>
              <div className={s.itemPrice_note}>
                <IconButton
                  style={{ padding: 0 }}
                  onClick={this.toggleCustomerNoteEdit}
                >
                  <Edit
                    style={
                      item.customerNote && item.customerNote.length > 0
                        ? { height: 18, color: "orange" }
                        : { height: 18 }
                    }
                  />
                </IconButton>
              </div>
              <div
                className={s.itemPrice}
                style={{ color: theme.palette.primary.main }}
              >
                $
                {(
                  (parseInt(item.quantityInCart) * parseInt(item.basePrice)) /
                  100
                ).toFixed(2)}
              </div>
            </div>
            {/* </div> */}

            {/* </div> */}
          </ListItem>

          <Dialog
            fullWidth
            open={isEditingCustomerNote}
            onClose={this.toggleCustomerNoteEdit}
            style={{ zIndex: 90004 }}
          >
            <div style={{ padding: 16, backgroundColor: "#FCFCFD" }}>
              <Formik
                initialValues={{
                  uuid: item.uuid,
                  customerNote: item.customerNote ?? "",
                }}
                onSubmit={(values, f) => {
                  modifyShoppingCartItemNote(item.uuid, values.customerNote)
                    .then((result) => {
                      f.setSubmitting(false);
                      if (result.error) {
                        if (result.error.validationErrors) {
                          const errors = getValidationErrors(
                            result.error.validationErrors
                          );
                          f.setErrors(errors);
                        } else {
                          openErrorSnackbar(
                            "Something went wrong. Please try again."
                          );
                        }
                      } else {
                        this.toggleCustomerNoteEdit();
                      }
                    })
                    .catch(() => {
                      f.setSubmitting(false);
                      openErrorSnackbar(
                        "Something went wrong. Please try again."
                      );
                    });
                }}
              >
                {(fp) => (
                  <Form className={s.dialog_field_form}>
                    <div className={s.field}>
                      <textarea
                        id="customerNote"
                        name="customerNote"
                        value={fp.values.customerNote}
                        placeholder="notes"
                        onChange={fp.handleChange}
                        onBlur={fp.handleBlur}
                        rows={8}
                        className={cx([
                          s.textarea,
                          fp.touched.customerNote &&
                          fp.errors.customerNote &&
                          s.invalid,
                        ])}
                      />
                      {fp.touched.customerNote && fp.errors.customerNote ? (
                        <Typography>{fp.errors.customerNote}</Typography>
                      ) : null}
                    </div>
                    <div className={s.dialog_field_actions}>
                      <Button type="submit" disabled={fp.isSubmitting}>
                        {fp.isSubmitting ? "Working..." : "Save"}
                      </Button>
                      <Button
                        type="button"
                        onClick={this.toggleCustomerNoteEdit}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Dialog>

          <Divider />
        </>
      </div>
    );
  }
}

function ReferralSection(props) {
  const { sdk } = React.useContext(SDKContext);
  const [code, setCode] = React.useState("");
  const [validatedReferralCode, setValidatedReferralCode] = React.useState(
    null
  );
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    props.setDisableChoosingPayment(true);
    sdk
      .checkReferralCode({ code })
      .then((result) => {
        setIsSubmitting(false);
        props.setDisableChoosingPayment(false);
        if (result.error) {
          props.setReferralCode(null);
          if (
            ["VALIDATION_ERROR", "INTERNAL_SERVER_ERROR"].includes(
              result.error.type
            )
          ) {
            setErrorMessage("Something went wrong. Please try again.");
          } else {
            setErrorMessage(result.error.message);
          }
        } else {
          props.setReferralCode(result.data);
          setValidatedReferralCode(result.data);
        }
      })
      .catch(() => {
        setIsSubmitting(false);
        props.setDisableChoosingPayment(false);
        props.setReferralCode(null);
        setErrorMessage("Something went wrong. Please try again.");
      });
  };
  const moneyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const percentFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <Paper className={s.referralSection}>
      <h1 className={s.referralSectionHeading}>Promo code?</h1>
      {validatedReferralCode ? (
        <div className={s.referralSectionValidatedReferralCodeLayout}>
          <div>
            <div className={s.referralSectionReferralName}>
              {validatedReferralCode.referralTemplate.name}
            </div>
            <div className={s.referralSectionValidatedReferralCodeSubLayout}>
              <div className={s.referralSectionReferralCode}>
                {validatedReferralCode.code}
              </div>
              <div className={s.referralSectionReferralAmount}>
                {validatedReferralCode.referralTemplate.refereeAmountKind ===
                  "FIXED"
                  ? moneyFormatter.format(
                    validatedReferralCode.referralTemplate.refereeAmount / 100
                  )
                  : validatedReferralCode.referralTemplate.refereeAmountKind ===
                    "PERCENT"
                    ? percentFormatter.format(
                      validatedReferralCode.referralTemplate.refereeAmount / 100
                    )
                    : null}
              </div>
              <div className={s.referralSectionReferralAmountSubText}>
                &nbsp;off
              </div>
            </div>
          </div>
          <Button
            type="button"
            onClick={() => {
              setCode("");
              setErrorMessage(null);
              setValidatedReferralCode(null);
              props.setReferralCode(null);
            }}
          >
            Remove
          </Button>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className={s.referralSectionInputs}>
            <Input
              required
              type="text"
              placeholder="Enter Code Here"
              value={code}
              onChange={(event) => {
                setCode(event.target.value);
              }}
              onBlur={() => {
                setErrorMessage(null);
              }}
            />
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <CircularProgress style={{ height: 24, width: 24 }} />
              ) : (
                "Apply"
              )}
            </Button>
          </div>
          {errorMessage == null ? null : (
            <div className={s.referralSectionErrorMessage}>{errorMessage}</div>
          )}
        </form>
      )}
    </Paper>
  );
}
